import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import GameLineup from '../Components/GameLineup';
import ManagerLogin from '../Components/ManagerLogin';
import TeamNotices from '../Components/TeamNotices';
import UpcomingGames from '../Components/UpcomingGames';
import config from '../config.json';
import axiosAuth from '../utils/axiosAuth';



const TeamPage = () => {
    const { teamId } = useParams();
    const navigate = useNavigate();
    const environment = process.env.REACT_APP_ENV;
    const baseApiUrl = environment ? config[environment].apiUrl : config.dev.apiUrl;
    const teamApiUrl = baseApiUrl + `teams/${teamId}`
    const [teamData, setTeamData] = useState(null);
    const [managerLoginOpen, setManagerLoginOpen] = useState(false);

    // useEffect hook to get the team data on every refresh of the page in order to keep the team information up to date
    useEffect(() => {
        console.log('Updating team data...');
        axiosAuth.get(teamApiUrl)
            .then(response => {
                setTeamData(response.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                navigate('/');
            });
    }, [teamApiUrl, navigate]);


    const handleOpenManagerLogin = () => {
        setManagerLoginOpen(true);
    }

    const handleCloseManagerLogin = () => {
        setManagerLoginOpen(false);
    }

    const boxStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 270,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4
      };

    return (
        <div>
        {teamData && teamData.notices ? (
        <div className="container">
            <h2>{teamData.name}</h2>
            <TeamNotices
                teamData={teamData}
                setTeamData={setTeamData}
            />
            <GameLineup 
                teamData={teamData}
                setTeamData={setTeamData}
                allowLogout={'allowLogout' in teamData ? teamData.allowLogout : false}
                showInfoButton={'allowLogout' in teamData ? teamData.allowLogout : false}
            />
            <div className='upcoming-games-container'>
                <UpcomingGames
                    teamData={teamData}
                    setTeamData={setTeamData}
                    allowEdit={false}
                />
            </div>
            <div id='tp-manager-login'>
                <Button onClick={handleOpenManagerLogin}>Manager Login</Button>
                <Modal
                    open={managerLoginOpen}
                    onClose={handleCloseManagerLogin}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box className="modal-box" sx={boxStyle}>
                        { managerLoginOpen ? (
                        <ManagerLogin teamId={teamId}/>
                        ) : null
                        } 
                    </Box>
                </Modal>
            </div>
            <div className='version-text'>
                <p>Alpha Version</p>
            </div>
        </div>
        
        ) : null}
        </div>
    );
};

export default TeamPage;